<div class="container-fluid">
    <div class="row mb-3">
        <div class="col-12">
            <h3>{{ isEdit ? 'Edit Ad Banner' : 'Add Ad Banner' }}</h3>
        </div>
    </div>

    <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-success" role="status"></div>
    </div>

    <div *ngIf="!loading" class="row">
        <div class="col-md-8">
            <div class="card">
                <div class="card-body">
                    <form [formGroup]="form" (ngSubmit)="submit()">

                        <div class="mb-3">
                            <label class="form-label">Banner Group *</label>
                            <select class="form-select" formControlName="bannerGroup">
                                <option value="" disabled>Select a group</option>
                                <option *ngFor="let g of bannerGroups" [value]="g.value">{{ g.label }}</option>
                            </select>
                            <div *ngIf="form.get('bannerGroup')?.touched && form.get('bannerGroup')?.invalid"
                                 class="text-danger small">Banner group is required</div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Position *</label>
                            <input type="number" class="form-control" formControlName="position" min="1">
                            <div *ngIf="form.get('position')?.touched && form.get('position')?.invalid"
                                 class="text-danger small">Position must be at least 1</div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label">URL (optional)</label>
                            <input type="text" class="form-control" formControlName="url" placeholder="https://example.com">
                        </div>

                        <div class="mb-3">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" formControlName="active" id="activeToggle">
                                <label class="form-check-label" for="activeToggle">Active</label>
                            </div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label">Image {{ isEdit ? '(leave empty to keep current)' : '*' }}</label>

                            <div *ngIf="isEdit && currentImagePath && !filePreview" class="mb-2 image-preview-area">
                                <p class="small text-muted mb-1">Current image:</p>
                                <img [src]="currentImagePath" alt="Current banner" class="img-thumbnail" style="max-height: 150px;">
                            </div>

                            <div *ngIf="filePreview" class="mb-2 image-preview-area new-preview">
                                <p class="small text-muted mb-1">New image:</p>
                                <img [src]="filePreview" alt="Preview" class="img-thumbnail" style="max-height: 150px;">
                            </div>

                            <input type="file" class="form-control" accept="image/*" (change)="onFileSelected($event)">
                            <div class="small text-muted mt-1">Accepted formats: PNG, JPG, JPEG. Max size: 5MB</div>

                            <button type="button" class="btn btn-sm btn-outline-secondary mt-2"
                                    *ngIf="selectedFile" (click)="clearFile()">
                                <i class="fa fa-times me-1"></i>Clear selection
                            </button>
                        </div>

                        <div class="d-flex gap-2">
                            <button type="submit" class="btn btn-success" [disabled]="submitting">
                                <i class="fa me-1" [ngClass]="submitting ? 'fa-spinner fa-spin' : (isEdit ? 'fa-save' : 'fa-plus')"></i>
                                {{ submitting ? 'Saving...' : (isEdit ? 'Update Ad Banner' : 'Create Ad Banner') }}
                            </button>
                            <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
                                Cancel
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
